export const ADD_TYPE = "ADD_TYPE";
export const REMOVE_TYPE = "REMOVE_TYPE";
export const RESET_TYPE = "RESET_TYPE";
export const OPEN_CUSTOM_FORM = "OPEN_CUSTOM_FORM";
export const CLOSE_CUSTOM_FORM = "CLOSE_CUSTOM_FORM";
export const ADD_CUSTOM_ITEM_START = "OPEN_CUSTOM_ITEM_START";
export const ADD_CUSTOM_ITEM = "ADD_CUSTOM_ITEM";
export const FETCH_ITEMS_TYPE_START = "FETCH_ITEMS_TYPE_START";
export const SET_ITEMS_TYPE = "SET_ITEMS_TYPE";
